/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const attendanceMetricsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.ATTENDANCE_METRICS + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.ATTENDANCE_METRICS + '_RESULT':
      return {
        ...state,
        data: action.result.data?.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.ATTENDANCE_METRICS + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
